import type { FaireProductEntity } from "../../entity_types/product";

export const p_eu3jdzfepf: FaireProductEntity = {
  token: "p_eu3jdzfepf",
  type: "product",
  name: "First Bible Basics",
  brandToken: "b_4q06brhpm1",
  brandName: "Harvest House Publishers Gift & Specialty Books",
  imageUrl:
    "https://cdn.faire.com/fastly/0ced6bf46e638ca4d71f99111fb42836907ccdf8c1555303a7147af4a1889efc.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/383da8680788760d4303007d5eda5e9f9603ed8cf5e8500015d2ac209f8a2b38.jpeg",
    "https://cdn.faire.com/fastly/1d76862c7380e5879ba4c5aa4fa40cc2296cd8b989259675553f2c713eef7aae.jpeg",
    "https://cdn.faire.com/fastly/ff5b14be7d800619d678d91c12048ce4a61f165b4a75e8dd63945b8527d48b76.jpeg",
  ],
  priceDollars: 9.01,
  description:
    "Buy 6 of any title and get the 7th free!\n\nTeach Your Child Counting and Bible Basics\n\nYour family will love this totally unique board book! Each page features colorful, engaging artwork, reframing abstract, but vitally important biblical content into the manageable concept of basic numbers (1-10) for your young child.\n\nFor your child...\nThey will delight in the bright illustrations and counting along with you. Also, they will be exposed to the vocabulary of basic theology in a format that will help them categorize and retain the information.\n\nFor you...\nYou'll appreciate the artistic design, engaging content, and helping your child learn to count. And who knows? You might even learn something about the Bible you didn't know before!\n\n \n\n*** \nBaby Believer primers are designed to grow with children, from early infancy through elementary school. In addition to basic Bible theology, Baby Believer board books are filled with quotations from the Bible, creeds, hymns, church fathers, and other articles of faith to help reinforce the content and provide intellectual handholds for older children who possess a greater capacity for learning and memorization.",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:31.070Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
